import { render, staticRenderFns } from "./PageIns.vue?vue&type=template&id=33e24f68&scoped=true&"
import script from "./PageIns.vue?vue&type=script&lang=js&"
export * from "./PageIns.vue?vue&type=script&lang=js&"
import style0 from "./PageIns.vue?vue&type=style&index=0&id=33e24f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e24f68",
  null
  
)

export default component.exports